import { useRouteError } from 'react-router-dom';

export default function RouteError() {
    const error = useRouteError();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg text-center">
                <div className="text-red-500 mx-auto w-16 h-16 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                </div>

                <h1 className="text-2xl font-bold text-gray-800 mb-2">Route Error</h1>
                <p className="text-gray-600 mb-4">
                    {error.statusText || error.message}
                </p>
                <p className="text-sm text-gray-500 mb-6">
                    Error code: {error.status || 500}
                </p>

                <a
                    href="/"
                    className="inline-block py-3 px-6 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition duration-200"
                >
                    Go to Homepage
                </a>
            </div>
        </div>
    );
}